const getGlobalState = (state) => state && state.global ? state.global : {};
export const info = (state) => getGlobalState(state).info;